// Production releases verified on September 18, 2026.
// Deployment evidence and the six-month review window: docs/product-updates.md.
export const productUpdates = [
  {
    title: 'More reliable return labels',
    date: '2026-09-16',
    description:
      'Open PDF return labels directly from return details, with clearer feedback if a label cannot open.',
  },
  {
    title: 'Flexible return fees',
    date: '2026-09-15',
    description:
      'Set fixed or percentage fees by SKU and refund or store-credit outcome, with previews before saving.',
  },
  {
    title: 'Return eligibility by product',
    date: '2026-09-08',
    description:
      'Exclude products from returns using Shopify tags, collections, or SKUs.',
  },
  {
    title: 'Shipment tracking & branding',
    date: '2026-09-08',
    description:
      'View shipment progress inside ShipAid and customize your customer tracking page with a live preview.',
  },
  {
    title: 'Returns & customer notifications',
    date: '2026-08-13',
    description:
      'Manage returns, exchanges, policies, incentives, and labels. Connect Klaviyo for delivery and return notifications.',
  },
  {
    title: 'Two-factor authentication',
    date: '2026-08-13',
    description:
      'Add an authenticator-code step to sign-in from your account settings.',
  },
  {
    title: 'Easier settings & notification controls',
    date: '2026-06-02',
    description:
      'Find settings in a dedicated sidebar and manage delivery email templates, sender details, and merchant alerts together.',
  },
  {
    title: 'Sales channel filtering',
    date: '2026-04-15',
    description:
      'Order totals and order charts follow your selected sales channel, with fresh data when switching filters.',
  },
];
